'use client';

import { createClient } from '@/utils/supabase/client';
import { useQuery } from '@tanstack/react-query';
import { DEFAULT_MAX_IMAGE_SIZE, MIN_IMAGE_SIZE, MAX_PREMIUM_IMAGE_SIZE } from '@/lib/constants';

export function useImageSettings() {
  const supabase = createClient();

  // Just use session - it's fast and has all the user metadata we need
  const { data: session } = useQuery({
    queryKey: ['session', 'imageSettings'], // More specific cache key
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      return session;
    },
    staleTime: 60000, // Cache for 1 minute
  });

  const user = session?.user;

  // Get max image size from user metadata, with default
  const maxImageSize = user?.user_metadata?.max_image_size
    ? parseInt(user.user_metadata.max_image_size, 10)
    : DEFAULT_MAX_IMAGE_SIZE;

  // Ensure the value is within reasonable bounds
  const clampedMaxSize = Math.max(MIN_IMAGE_SIZE, Math.min(MAX_PREMIUM_IMAGE_SIZE, maxImageSize));

  return {
    maxImageSize: clampedMaxSize,
    isCustomSize: user?.user_metadata?.max_image_size !== undefined
  };
}
